import { Manager, Socket } from 'socket.io-client';
import { IS_PROD } from '../firebase';

const LOG = true; //!IS_PROD;

class SocketSingletonCreator {
  socket: Socket | undefined;

  private validateThatSocketConnectionWasEstablishedBefore() {
    if (!this.socket) {
      throw new Error(
        'Authorized socket connection was not established before'
      );
    }
  }

  createAuthorizedConnection(token: string) {
    if (this.socket) {
      this.socket.disconnect();
    }

    const manager = new Manager(process.env.REACT_APP_API_ENDPOINT, {
      transports: ['websocket', 'polling'],
    });

    // any-namespace '/'
    this.socket = manager.socket('/', {
      auth: { token }, // this is secure way to pass "token"
    });

    this.socket.on('connect', () => {
      if (LOG) {
        console.warn(`Socket connection was established: ${this.socket?.id}`);
      }
    });

    this.socket.on('connect_error', () => {
      if (LOG) {
        console.warn(`Socket connection error. Trying to reconnect...`);
      }
    });

    this.socket.on('disconnect', () => {
      console.error('Socket disconnected.');
    });

    this.socket.connect();
  }

  emit(ev: string, data: any) {
    if (LOG) console.log(`New socket event emmited '${ev}'.`);
    this.validateThatSocketConnectionWasEstablishedBefore();
    this.socket!.emit(ev, data);
  }

  on(ev: string, listener: (...args: any[]) => void) {
    if (LOG) console.log(`New socket listener at '${ev}'.`);
    this.validateThatSocketConnectionWasEstablishedBefore();
    this.socket!.on(ev, listener);
  }

  off(ev: string, listener?: (...args: any[]) => void) {
    if (LOG) console.log(`Removed socket listener at '${ev}'.`);
    this.validateThatSocketConnectionWasEstablishedBefore();
    this.socket!.off(ev, listener);
  }
}

export const socket = new SocketSingletonCreator();
